import React from 'react';
import { Modal } from 'antd';
import Space from 'Components/common/Space/Space';
import AppButton from 'Components/common/Forms/AppButton/AppButton';
import styles from './FeatModal.styles';

export default function FeatModal({
  visible,
  onCancel,
  title,
  subtitle,
  info1,
  info2,
  buttonText,
  buttonAction,
  popUpImage,
  ...props
}) {
  return (
    <Modal open={visible} width={'50%'} footer={null} onCancel={onCancel}>
      <div style={styles.popUpContainer}>
        <div style={{ marginTop: 32 }}>
          <div style={styles.popupLeft}>{title}</div>
          <div style={styles.popupSubtitle}>{subtitle}</div>
          <Space height={16} />

          <div style={styles.popupText}>{info1}</div>
          <Space height={8} />
          <div style={styles.popupText}>{info2}</div>

          <div style={styles.buttonContainer}>
            <AppButton text={buttonText} action={buttonAction} />
          </div>
        </div>

        <img src={popUpImage} style={styles.popupImage} />
      </div>
    </Modal>
  );
}
